const SCROLLING_CLASS = "is-scrolling";
const IDLE_MS = 800;

export function setupScrollbarAutoHide() {
  const timers = new WeakMap<Element, number>();

  document.addEventListener(
    "scroll",
    (event) => {
      const target = event.target;
      const element =
        target instanceof Element
          ? target
          : target instanceof Document
            ? document.documentElement
            : null;
      if (!element) return;

      element.classList.add(SCROLLING_CLASS);

      const existing = timers.get(element);
      if (existing !== undefined) window.clearTimeout(existing);

      const timer = window.setTimeout(() => {
        element.classList.remove(SCROLLING_CLASS);
        timers.delete(element);
      }, IDLE_MS);

      timers.set(element, timer);
    },
    { capture: true, passive: true },
  );
}
